module.exports = __webpack_public_path__ + "static/media/UI-Accept.8ae720fe.wav";